import { cn } from '@/lib/utils';

const MAX_WIDTH_CLASSES = {
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  full: 'max-w-none',
};

export function PageShell({
  children,
  className,
  contentClassName,
  maxWidth = '7xl',
  padded = true,
  animate = true,
  'data-testid': dataTestId,
}) {
  const maxWidthClass = MAX_WIDTH_CLASSES[maxWidth] || maxWidth;

  return (
    <div
      className={cn(
        padded && 'px-4 py-6 sm:px-6 lg:px-8',
        animate && 'animate-fade-in',
        className
      )}
      data-testid={dataTestId}
    >
      <div className={cn('mx-auto w-full space-y-6', maxWidthClass, contentClassName)}>
        {children}
      </div>
    </div>
  );
}
